import {TemplateList} from "~/libs/constants/TemplateList"
import {HeaderConfig} from "~/config/HeaderConfig"
import {DEFAULT_STICKY_HEADER_TOP_OFFSET} from "~/libs/constants/constants"
export const useHeaderConfig = () => {
  const getConfig = () => {
    type TemplateListKeys = keyof typeof TemplateList;
    const uniWebTemplateName:TemplateListKeys | undefined = useRuntimeConfig().public.uniWebTemplateName ? String(useRuntimeConfig().public.uniWebTemplateName).toUpperCase() as TemplateListKeys : undefined
    if (uniWebTemplateName && (uniWebTemplateName in TemplateList)) {
      return HeaderConfig[TemplateList[uniWebTemplateName]]
    }
    return {}
  }


  const getStickyTopOffset = () => {
    const headerConfig = getConfig()
    return headerConfig.stickyTopOffset || DEFAULT_STICKY_HEADER_TOP_OFFSET
  }

  return {
    getConfig,
    getStickyTopOffset
  }
}


